/**
 * L2-P1: moved to @miq/shared-models (models/language.model.ts). This shim keeps the old
 * import path working; new code should import from '@miq/shared-models'.
 */
export type { LanguageLocale } from '@miq/shared-models';
export { LocaleId, PACIFC_COUNTRIES, LANGUAGE_BY_LOCALEID, DEPRECATED_LANGUAGES, LocaleChinaHkChinese, LocaleChinaHkEnglish, LocaleHkEnglishChines, LocaleChinaHkChineseEnglish } from '@miq/shared-models';
